import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import InfoItem from "components/common/detailsPage/InfoItem";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { StatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect} from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getStoreCameraDetails } from "store/slices/storeCameraSlice";
import { getLocalizedField } from "utils/utils";

function StoreCameraDetails() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { loading, itemDetails: storeCameraDetails } = useSelector(
    (state) => state.StoreCamera,
  );

  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("localserver");

  useEffect(() => {
    if (id && canView) {
      dispatch(getStoreCameraDetails(id));
    }
  }, [id, dispatch, canView]);

  const branchBasicInformationFields = [
    {
      label: t("Id"),
      value: storeCameraDetails?._id || "-",
      col: { lg: 6 },
    },
    {
      label: t("Store"),
      value: getLocalizedField(storeCameraDetails?.branchId?.name , language) || "-",
      col: { lg: 6 },
    },
    { isSpacer: true },
    {
      label: t("Name"),
      value: storeCameraDetails?.name || "-",
      col: { lg: 6 },
    },
    {
      label: t("Camera Id"),
      value: storeCameraDetails?.cameraId || "-",
      col: { lg: 6 },
    },

    { isSpacer: true },
    {
      label: t("Role"),
      value: storeCameraDetails?.role || "-",
      col: { lg: 6 },
    },
    {
      label: t("Last updated By"),
      value: storeCameraDetails?.updatedBy?.name || "-",
      col: { lg: 6 },
    },
    { isSpacer: true },
    {
      label: t("Status"),
      render: <StatusBadge status={storeCameraDetails?.status} t={t} />,
      col: { lg: 6 },
    },
  ];

  const shimmerLayout = [
    {
      col: 8,
      blocks: [
        { rows: 4, cols: 2 },
        { rows: 1, cols: 1 },
      ],
    },
  ];

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Store Camera Details")} />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page branch_details">
      <DetailsTitle title={t("Store Camera Details")} />
      <Row>
        <Col lg={8} className="ps-0">
          <div className="common_card" style={{ height: "calc(100% - 20px)" }}>
            <Row>
              <Col lg={12} className="mb-3">
                <h2 className="title_20">{t("Basic Details")}</h2>
              </Col>

              {branchBasicInformationFields.map((item, index) => {
                if (item.isSpacer) {
                  return <div key={index} className="mt-4 w-100" />;
                }

                return (
                  <InfoItem
                    key={index}
                    label={item.label}
                    value={item.value}
                    col={item.col}
                  >
                    {item.render}
                  </InfoItem>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StoreCameraDetails;
